// Shapes of the appraisal API (docs/superpowers/plans/2026-10-01-appraisals.md). Dates are ISO strings:
// `yyyy-MM-dd` for dates, full ISO for date-times.

export type CycleStatus = 'DRAFT' | 'ACTIVE' | 'CLOSED';
export type ReviewStatus = 'PENDING' | 'SELF_SUBMITTED' | 'MANAGER_SUBMITTED' | 'ACKNOWLEDGED';
export type Band = 'UNSATISFACTORY' | 'NEEDS_IMPROVEMENT' | 'MEETS' | 'EXCEEDS' | 'OUTSTANDING';
export type ViewerRole = 'ADMIN' | 'EMPLOYEE' | 'REVIEWER';

export const REVIEW_STATUSES: ReviewStatus[] = ['PENDING', 'SELF_SUBMITTED', 'MANAGER_SUBMITTED', 'ACKNOWLEDGED'];
export const BANDS: Band[] = ['UNSATISFACTORY', 'NEEDS_IMPROVEMENT', 'MEETS', 'EXCEEDS', 'OUTSTANDING'];
export const MAX_CRITERIA = 15;

export interface ICycleRequest {
    name: string;
    periodStart: string;
    periodEnd: string;
    selfReviewDue: string;
    managerReviewDue: string;
}

export interface ICriterionRequest {
    name: string;
    description?: string;
    weight: number;
}

export interface ICriterion {
    id: string;
    name: string;
    description?: string | null;
    weight: number;
    sortOrder: number;
}

export interface ICycleSummary {
    id: string;
    name: string;
    periodStart: string;
    periodEnd: string;
    selfReviewDue: string;
    managerReviewDue: string;
    status: CycleStatus;
    participantCount: number;
    completedCount: number;
}

export interface ICycleDetail extends ICycleSummary {
    criteria: ICriterion[];
    weightTotal: number;
    startedAt?: string | null;
    closedAt?: string | null;
}

export interface IAddParticipantsRequest {
    all?: boolean;
    departmentIds?: string[];
    userIds?: string[];
}

export interface IPerson {
    userId: string;
    name: string;
    departmentNames: string[];
}

export interface IReviewSummary {
    id: string;
    cycleId: string;
    cycleName: string;
    cycleStatus: CycleStatus;
    employee: IPerson;
    reviewer?: IPerson | null;
    status: ReviewStatus;
    selfReviewDue: string;
    managerReviewDue: string;
    managerScore?: number | null;
    band?: Band | null;
}

export interface IRatingPart {
    criterionId: string;
    score?: number | null;
    comment?: string | null;
}

export interface IReviewPart {
    overallComment?: string | null;
    submittedAt?: string | null;
    score?: number | null;
    ratings: IRatingPart[];
}

export interface IReviewDetail extends IReviewSummary {
    criteria: ICriterion[];
    viewerRole: ViewerRole;
    self?: IReviewPart | null;
    manager?: IReviewPart | null;
    acknowledgement?: { comment?: string | null; acknowledgedAt: string } | null;
}

export interface IReviewPartRequest {
    overallComment?: string;
    ratings: { criterionId: string; score?: number; comment?: string }[];
}

export interface ReviewFilters {
    status?: ReviewStatus;
    departmentId?: string;
}
